module.exports = __webpack_public_path__ + "static/media/ASCGLOGO.47f586da.png";